import { BlueprintDeploymentStack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";

const TemplateDeploymentStacksRowActionsCell = ({
  ...cellProps
}: TableSimpleCellProps<BlueprintDeploymentStack>) => {
  return <TableSimpleCell {...cellProps} />;
};

export default TemplateDeploymentStacksRowActionsCell;
